import { Auth } from "aws-amplify"

export async function apiRequest(
  path: string,
  method: string = "GET",
  data: object,
  baseUrl: string | undefined = process.env.NEXT_PUBLIC_API_URL,
  customAuth: string | undefined = undefined
) {
  // synchronously get the accessToken from localStorage since it should be there after authenticating
  // see: https://github.com/aws-amplify/amplify-js/issues/1792
  // const lastUserIdFromLocalStorage = localStorage.getItem(
  //   `CognitoIdentityServiceProvider.${process.env.NEXT_PUBLIC_AWS_COGNITO_USER_POOL_CLIENT_ID}.LastAuthUser`
  // )
  // const accessToken = localStorage.getItem(
  //   `CognitoIdentityServiceProvider.${process.env.NEXT_PUBLIC_AWS_COGNITO_USER_POOL_CLIENT_ID}.${lastUserIdFromLocalStorage}.accessToken`
  // )
  // const idToken = localStorage.getItem(
  //   `CognitoIdentityServiceProvider.${process.env.NEXT_PUBLIC_AWS_COGNITO_USER_POOL_CLIENT_ID}.${lastUserIdFromLocalStorage}.idToken`
  // )

  // async grab the access token
  const session = await Auth.currentSession()
  // @ts-ignore
  const accessToken = session.accessToken.jwtToken

  // check to see if there is a user to impersonate
  let impersonationId = undefined
  if (typeof localStorage !== "undefined") {
    const item = localStorage.getItem("impersonation") || ""
    if (item) {
      const jsonItem = JSON.parse(item)
      if (jsonItem) {
        impersonationId = jsonItem?.id
      }
    }
  }

  return fetch(`${baseUrl}/${path}`, {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Authorization: customAuth || `${accessToken}`,
      ...(impersonationId && { "luz-impersonation-id": impersonationId }),
    },
    body: data ? JSON.stringify(data) : undefined,
  })
    .then(async response => {
      if (!response.ok) {
        const resp = await response.json()
        throw new Error(resp?.message)
      }
      return response.json()
    })
    .then(response => {
      if (response.status === "error") {
        // Automatically signout user if accessToken is no longer valid
        if (response.code === "auth/invalid-user-token") {
          // do we want to sign out here?
        }

        throw new CustomError(response.code, response.message)
      } else {
        return response
      }
    })
}

// Create an Error with custom message and code
export class CustomError {
  constructor(code: string, message: string) {
    const error: any = new Error(message)
    error.code = code
    return error
  }
}
